var _DEFAULT_PARAMS;
import { END_PERIOD_PARAM_KEY, LASTNOBS_PARAM_KEY, LAST_N_PERIODS_PARAM_KEY, START_PERIOD_PARAM_KEY } from './params';
export var DATAFLOW_ANNOTATIONS_PATH = ['data', 'dataflows', 0, 'annotations'];
export var DEFAULT_ANNOT_TYPE = 'DEFAULT';
export var DEFAULT_LASTNOBS_VAL = '1';
export var MICRODATA = 'DRILLDOWN';
export var NO_DISPLAY_ANNOT_TYPE = 'NOT_DISPLAYED';
export var START_PERIOD_ANNOT = 'TIME_PERIOD_START';
export var END_PERIOD_ANNOT = 'TIME_PERIOD_END';
export var LASTNOBS_ANNOT = 'LASTNOBSERVATIONS';
export var LAST_N_PERIODS = 'LASTNPERIODS';
export var DEFAULT_PARAMS = (_DEFAULT_PARAMS = {}, _DEFAULT_PARAMS[START_PERIOD_ANNOT] = START_PERIOD_PARAM_KEY, _DEFAULT_PARAMS[END_PERIOD_ANNOT] = END_PERIOD_PARAM_KEY, _DEFAULT_PARAMS[LASTNOBS_ANNOT] = LASTNOBS_PARAM_KEY, _DEFAULT_PARAMS[LAST_N_PERIODS] = LAST_N_PERIODS_PARAM_KEY, _DEFAULT_PARAMS);
export var LAYOUT_ANNOTATIONS_TYPES = ['LAYOUT_ROW', 'LAYOUT_COLUMN', 'LAYOUT_ROW_SECTION'];
export var LAYOUT_KEYS = {
  LAYOUT_COLUMN: 'header',
  LAYOUT_ROW: 'rows',
  LAYOUT_ROW_SECTION: 'sections'
};